import React, { useState } from "react";
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  GroupItem,
} from "devextreme-react/form";
import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  Lookup,
} from "devextreme-react/data-grid";
import Button from "devextreme-react/button";
import LoadIndicator from "devextreme-react/load-indicator";
import { useAuth } from "../../contexts/auth";
import axios from "axios";
import { backendlink } from "../../config";
import { Toast } from "devextreme-react/toast";
import GroupCaption from "../../pages/group-caption/GroupCaption";

export default function CustomerEcgDeviceSearchPatientForm({
  onClose,
  onSelect,
}) {
  const { user } = useAuth();

  const [loadingSearchButton, setLoadingSearchButton] = useState(false);
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    email: "",
    phone: "",
  });

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const handleSelectionChanged = (e) => {
    setSelectedRowKeys(e.selectedRowKeys);
  };

  const [patientList, setPatientList] = useState([]);

  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "success",
    message: "",
  });

  const groupCaptionNamedRender = (iconName) => {
    const groupCaptionRender = (data) => (
      <GroupCaption iconName={iconName} {...data} />
    );
    return groupCaptionRender;
  };

  const onSelectPatient = () => {
    if (selectedRowKeys.length === 0) {
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: "error",
        message: "Please select a row first",
      });
      return;
    }
    onSelect(selectedRowKeys);
    onClose();
    setSelectedRowKeys([]);
    setFormData({
      name: "",
      email: "",
      phone: "",
    });
  };

  const onClickSearchButton = async (e) => {
    setLoadingSearchButton(true);

    try {
      const response = await axios
        .get(backendlink + "customer/getpatientsbynamephonemail", {
          params: {
            organizationToken: user.userToken,
            patientName: formData.patientName,
            phone: formData.phone,
            email: formData.email,
          },
          headers: {
            token: user.token,
          },
        })
        .then((res) => {
          setLoadingSearchButton(false);

          if (res.data.errorno === 0) {
            const outputArray = res.data.result[0].map((item) => {
              var statusString =
                item.isEnabled === true ? "Active" : "Inactive";

              return {
                name: item.name,
                phone: item.phone,
                email: item.username,
                status: statusString,
                patientToken: item.userToken,
              };
            });
            setPatientList(outputArray);
          } else {
            alert(res.data.errmessage);
          }
        });
    } catch (error) {
      setLoadingSearchButton(false);
      alert(error);
    }
  };

  function onHiding() {
    setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  }

  return (
    <div>
      <form>
        <Form
          formData={formData}
          disabled={false}
          style={{ paddingTop: "20px" }}
        >
          <GroupItem
            iconName="user"
            captionRender={groupCaptionNamedRender("user")}
            caption="Search Criteria"
            colCount={3}
          >
            <Item dataField={"patientName"} editorType={"dxTextBox"}>
              <Label text="Patient Name" />
            </Item>
            <Item dataField={"email"} editorType={"dxTextBox"}>
              <Label text="Email" />
            </Item>
            <Item dataField={"phone"} editorType={"dxTextBox"}>
              <Label text="Phone Number" />
            </Item>
          </GroupItem>

          <ButtonItem colSpan={4} cssClass="full-width-button">
            <ButtonOptions
              width={"100%"}
              type={"default"}
              useSubmitBehavior={false}
              onClick={onClickSearchButton}
            >
              <span className="dx-button-text">
                {loadingSearchButton ? (
                  <LoadIndicator
                    width={"24px"}
                    height={"24px"}
                    visible={true}
                  />
                ) : (
                  "Search"
                )}
              </span>
            </ButtonOptions>
          </ButtonItem>
        </Form>
      </form>
      
      <React.Fragment>
        <Form colCount={1} style={{ paddingTop: "20px" }}>
          <GroupItem caption="Patient List" iconName="group" colCount={1} />
        </Form>
        <DataGrid
          dataSource={patientList}
          selection={{ mode: "single" }}
          selectedRowKeys={selectedRowKeys}
          onSelectionChanged={handleSelectionChanged}
        >
          <Column dataField="name" caption="Patient Name" />
          <Column dataField="email" caption="Contact Email" />
          <Column dataField="phone" caption="Phone Number" />
          <Column dataField="status" caption="Status" />
          <Pager allowedPageSizes={[5, 10, 20]} showPageSizeSelector={true} />
          <Paging defaultPageSize={5} />
          <FilterRow visible={true} />
          <Lookup />
        </DataGrid>

        <Button
          type="default"
          text="Select"
          onClick={(data) => {
            onSelectPatient(data);
          }}
          style={{ width: "100%" }}
          className="full-width-button"
        />
      </React.Fragment>

      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={onHiding}
        displayTime={2000}
      />
    </div>
  );
}